export default __webpack_public_path__ + "static/media/send-sidebar-ic.528538a0.svg";